import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-browser-print',
  templateUrl: './browser-print.component.html',
  styleUrls: ['./browser-print.component.css']
})
export class BrowserPrintComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
